import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useContainer } from 'unstated-next';

import Loadable from '../../../components/common/loadable';
import { Exporter } from '../../../components/recordings/Exporter';
import { UsageStats } from '../../../components/recordings/UsageStats';
import { useSchoolInfo } from '../../../hooks/useSchoolInfo';
import AdminSettingsContainer from '../AdminSettingsContainer';
import StyledFormTitle from '../styles/form-title';

const RecordingsTab = () => {
    const { data: schoolInfo } = useSchoolInfo();
    const schoolUuid = schoolInfo?.uuid as string;

    const { t } = useTranslation('admin_settings');
    const { usageStats, isLoadingRecordingUsage } = useContainer(AdminSettingsContainer);

    if (!schoolUuid) {
        return null;
    }

    return (
        <>
            <StyledFormTitle>{t('recordings.title')}</StyledFormTitle>
            <Loadable fullScreen={false} isLoading={isLoadingRecordingUsage}>
                {usageStats && (
                    <UsageStats
                        isLoading={isLoadingRecordingUsage}
                        totalRecordings={usageStats.totalRecordings}
                        totalSize={usageStats.totalSize}
                        quota={usageStats.quotaSize}
                    />
                )}

                <Box>
                    <Exporter sx={{ mt: 3 }} />
                </Box>
            </Loadable>
        </>
    );
};

export default RecordingsTab;
